'use client';
import { useEffect } from 'react';
import UKDialog from '../UKDialog';
import style from './index.module.scss';
import { useTranslation } from '@/i18n/client';
import { downloadJoybuyApp } from '@/utils/deepLink';
import clearChannelActivityData from '@/utils/activityUtil';
import { EXPOSURE_RECORD, sendClickTrack } from '@/tracks/33529';
import PromotionExpiredSVG from '@/assets/icons/promotionExpired.svg';

interface DialogType {
  open: boolean;
  content: string;
  handleCancel: () => void;
}

/**
 * 促销过期弹窗
 * @param open 是否显示
 * @param content 说明文字
 * @param handleCancel 关闭回调
 */
const PromotionExpiredDialog = ({ open, content, handleCancel }: DialogType) => {
  const { t } = useTranslation();

  const handlerClose = () => {
    sendClickTrack.M_ChannelPrice_Fail_Popup_Click({
      button_name: 'cancel',
    });
    handleCancel?.();
  };

  const handlerOpenJoybuy = () => {
    sendClickTrack.M_ChannelPrice_Fail_Popup_Click({
      button_name: 'open joybuy',
    });
    downloadJoybuyApp();
    handleCancel?.();
  };

  useEffect(() => {
    if (open) {
      clearChannelActivityData();
    }
  }, [open]);

  return (
    <UKDialog
      open={open}
      handleCancel={handlerClose}
      handleClose={handlerOpenJoybuy}
      textContainerStyle={{ padding: '0' }}
      cancelButtonText={t('common.btnText.cancel')}
      customButtonText={t('common.message.OpenJoybuy')}
    >
      <div
        className={style.container}
        exptag={'exp|' + EXPOSURE_RECORD.M_ChannelPrice_Fail_Popup_Expo}
      >
        <PromotionExpiredSVG />
        {!!content && <div className={style.description}>{content}</div>}
      </div>
    </UKDialog>
  );
};

export default PromotionExpiredDialog;
